import { Component, HostBinding, inject, ChangeDetectionStrategy } from '@angular/core';
import { SideMenusService } from '@shared/components/side-menus/side-menus.service';
import { BasketComponent } from '@features/associations/components/basket/basket.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'abook-basket-menu',
    templateUrl: './basket-menu.component.html',
    styleUrls: ['./basket-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BasketComponent, MatButtonModule, MatIconModule]
})
export class BasketMenuComponent {
  private sideMenusService = inject(SideMenusService);

  @HostBinding('class.actions-on-top') topActions = true;
  @HostBinding('class.actions-on-bottom') bottomActions = true;

  closeAltMenu(): void {
    this.sideMenusService.toggleAltMenuSubject.next('close');
  }
}
